import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useTaskActions } from '../context/TaskContext';

export const useTaskFromUrl = () => {
  const location = useLocation();
  const history = useHistory();
  const { openViewTask, openAddTask } = useTaskActions();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const taskId = searchParams.get('id');
    const shouldOpenTask = searchParams.get('openTask');

    if (taskId) {
      // Open the task with minimal data - ViewTaskRefactored will fetch full details
      openViewTask({
        task_id: taskId,
        pk: `task#${taskId}`, // Add pk format for consistency
      });
    } else if (shouldOpenTask === 'true') {
      // Open add task modal when openTask=true is in URL
      openAddTask();
      // Clean up URL parameter after opening modal
      searchParams.delete('openTask');
      history.replace({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
    }
  }, [location.search]); // Only re-run when search params change
};
